interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const BillIcon = (props: PropsType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="2" y1="18.5" x2="18" y2="18.5" stroke="black" />
      <path
        d="M4 2V19H8.8V16.3438H11.2V19H16V2H4ZM7.3 12.8019H5.5V10.6769H7.3V12.8019ZM7.3 9.08316H5.5V6.95816H7.3V9.08316ZM7.3 5.36441H5.5V3.23941H7.3V5.36441ZM10.9 12.8019H9.1V10.6769H10.9V12.8019ZM10.9 9.08316H9.1V6.95816H10.9V9.08316ZM10.9 5.36441H9.1V3.23941H10.9V5.36441ZM14.5 12.8019H12.7V10.6769H14.5V12.8019ZM14.5 9.08316H12.7V6.95816H14.5V9.08316ZM14.5 5.36441H12.7V3.23941H14.5V5.36441Z"
        fill="black"
      />
    </svg>
  );
};

export default BillIcon;
